import Api from '../http.service';
/**
 * calendarEvents
 * @param {object} payload
 * @param {String} payload.culture
 * @param {String} payload.month
 * @param {String} payload.year
 */
export const calendarEvents = ({ culture, month, year }) =>
  Api.GET({
    url: `calendar_event/month/${culture}/${month}/${year}`,
  });

/**
 * calendarEvents
 * @param {object} payload
 * @param {String} payload.countryAbr
 * @param {String} payload.month
 * @param {String} payload.dateType
 */
export const getCalandarEventByCountry = ({ countryAbr, month, dateType }) =>
  Api.GET({
    url: `calendar_event/${countryAbr}/${month}?dateType=${dateType}`,
  });
